import type { SalesTeamSummary } from '../../types/salesTeam';

export function TeamSwitcher({
  teams,
  value,
  onChange,
}: {
  teams: SalesTeamSummary[];
  value: string | null; // null = All Teams
  onChange: (teamId: string | null) => void;
}) {
  return (
    <label className="inline-flex items-center gap-2 text-sm">
      <span className="text-gray-500 dark:text-gray-400">Team</span>
      <select
        aria-label="Team"
        value={value ?? 'all'}
        onChange={(e) => onChange(e.target.value === 'all' ? null : e.target.value)}
        className="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-2 py-1 text-sm text-gray-900 dark:text-gray-100"
      >
        <option value="all">All Teams</option>
        {teams.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name}
          </option>
        ))}
      </select>
    </label>
  );
}
